import React from 'react';
import styled from 'styled-components';
import { LightButton } from '../../Button/Button';

interface Props {
  textGrey?: string;
  textBold?: string;
  textNum?: string;
  textWhite?: string;
}

export const WhoToFollowItems = ({ textGrey, textWhite }: Props) => {
  return (
    <div className="row d-flex justify-content-around align-items-center w-100 gap-3 m-0 p-0 my-2" style={{ overflow: 'hidden' }}>
      <div className="col-2 m-0 p-0">
        <img
          src="https://i.pravatar.cc/100"
          style={{ width: '40px', height: '40px', borderRadius: '100%' }}
          alt="Avatar"
          className="m-0 p-0"
        />
      </div>
      <div className="col-4 d-flex justify-content-center align-items-center m-0 p-0">
        <Styled.TextP>
          <Styled.TextWhite>{textWhite}</Styled.TextWhite>
          <Styled.TextGrey>{textGrey}</Styled.TextGrey>
        </Styled.TextP>
      </div>
      <div className="col-4 m-0 p-0">
        <LightButton nameButton="Follow" />
      </div>
    </div>
  );
};

export const TrendsForYouItems = ({ textGrey, textBold, textNum }: Props) => {
  return (
    <>
      <Styled.MailWrapper className="col-12">
        <Styled.TextP>
          <Styled.TextGrey>{textGrey}</Styled.TextGrey>
          <Styled.TextBold>{textBold}</Styled.TextBold>
          <Styled.TextGrey>{textNum}</Styled.TextGrey>
        </Styled.TextP>
      </Styled.MailWrapper>
    </>
  );
};

export const Styled = {
  Container: styled.div`
    flex-direction: row;
    background: ${props => props.theme.RightSide.wrapperOne.background};
    border-radius: 15px;
    color: ${props => props.theme.RightSide.wrapperTwo.accountName.color};
    margin: 0px;
    margin-top: 15px;
  `,
  ImgWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 15px;
    weight: 15px;
  `,
  MailWrapper: styled.div`
    display: grid;
    align-items: center;
    justify-content: flex-strat;
  `,
  TitleP: styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-strat;
    padding-left: 10px;
    height: 50px;
    font-weight: bold;
  `,
  TextP: styled.div`
    align-items: center;
    justify-content: flex-strat;
    color: ${props => props.theme.RightSide.wrapperTwo.accountName.color};
  `,
  TextGrey: styled.p`
    color: grey;
    font-size: 11px;
    margin: 0;
  `,
  TextWhite: styled.p`
    color: ${props => props.theme.RightSide.wrapperTwo.accountName.color};
    height: 20px;
    margin-bottom: 0px;
  `,
  TextBold: styled.p`
    font-weight: bold;
    color: ${props => props.theme.RightSide.wrapperTwo.accountName.color};
  `,
};
